export const SUPPRESS_CONFIG_DOCS_MODAL_KEY = "arc-suppress-config-docs-modal";

export const localStorageKeys = {
	SUPPRESS_CONFIG_DOCS_MODAL_KEY
};

export const SUPPORTED_FILE_EXTENSIONS = [
	"csv",
	"doc",
	"docx",
	"eml",
	"jpeg",
	"msg",
	"pdf",
	"png",
	"rtf",
	"txt",
	"xlsx",
	"xml",
	"zip"
];

export const GRID_PAGE_SIZE_OPTIONS = [50,100,500];

// reduce this value to test result limit
export const MAX_SEARCH_RESULT_TOTAL = 100000;